module.exports = __webpack_public_path__ + "images/Stochastic.png?v=bbe552f489c4db03d46a7697b8e4dfc5";